import React from "react";
import { useSelector } from "react-redux";
import QuantityInput from "components/quantity-input";
import ProductModal from "components/product/modal";
import SubscriptionQuantityInput from "components/subs-quantity-input";
import ProductSummary from "components/product/summary";
import extractIdFromGid from "helpers/extract-gid";
import Link from "helpers/link";
import { openKlaviyoForm } from "utils/klaviyo";
import { useGlobalContext } from "context/global";

const ProductItem = ({ product, isOpen, openModal, closeModal, openCart = false, addToSub, hideATCPrice, newLayout = false }) => {
	const { image, title, variant, _type, requireLoginToBuy, earlyAccess, klaviyoFormId, type } = product;
	const { authenticated } = useSelector((state) => state.account.profile);
	const { translation, isSubscriptionPage } = useGlobalContext();
	const { activeBox } = useSelector((state) => state.cart);
	const { lines, subscriptionId } = useSelector((state) => state.account.subscription);

	const productVariantId = extractIdFromGid(variant?.id);

	// TODO: Refactor below code
	const ProductContentSelector = () => {
		const isInSubscription = lines[productVariantId];
		const stock = variant?.stock;

		if (earlyAccess && klaviyoFormId) {
			return <div className="bg-black text-white rounded-2xl text-base py-1 px-4 table mt-2 m-auto cursor-pointer"
				onClick={() => openKlaviyoForm(klaviyoFormId)}
				role="button"
				tabIndex={0}>
				{translation?.product?.earlyAccess}</div>;
		}


		if (!isInSubscription && (stock === "unavailable" || (!isSubscriptionPage && stock === "subscription-available"))) {
			return <div className="disabled-buy-message"> 	{translation?.product?.soldOut} </div>;
		}

		if (isSubscriptionPage || (addToSub && subscriptionId))
			return <SubscriptionQuantityInput productVariantId={productVariantId} stock={stock} product={product} />;


		if (!authenticated && requireLoginToBuy)
			return <Link to="/account/login" className="disabled-buy-message"> 	{translation?.product?.loginToBuy} </Link>;

		if (activeBox)
			return <QuantityInput product={{ variant, image, title, _type, type }} openCart={openCart} newLayout={newLayout} />;

		return <></>;
	};

	return (
		<>
			<ProductSummary openModal={openModal} product={product} hideATCPrice={hideATCPrice} newLayout={newLayout}>
				{!hideATCPrice && <ProductContentSelector />}
			</ProductSummary>
			<ProductModal isOpen={isOpen} close={closeModal} product={product} hideATCPrice={hideATCPrice} />
		</>
	);
};

export default ProductItem;
